import { useFetchPlannableStats } from './hooks/useFetchPlannableStats'

class PlannableService {
  stats = {
    useFetchPlannableStats
  }
}

export const plannableService = new PlannableService()
